export enum BankStatusCode {
  BANK_STATUS_CODE_ = 'BANK_STATUS_CODE',
  BANK_STATUS_CODE_NOT_PROVIDED = 'BANK_STATUS_CODE_NOT_PROVIDED',
  BANK_STATUS_CODE_AB01 = 'BANK_STATUS_CODE_AB01',
  BANK_STATUS_CODE_AB02 = 'BANK_STATUS_CODE_AB02',
  BANK_STATUS_CODE_AB03 = 'BANK_STATUS_CODE_AB03',
  BANK_STATUS_CODE_AB04 = 'BANK_STATUS_CODE_AB04',
  BANK_STATUS_CODE_AB05 = 'BANK_STATUS_CODE_AB05',
  BANK_STATUS_CODE_AB06 = 'BANK_STATUS_CODE_AB06',
  BANK_STATUS_CODE_AB07 = 'BANK_STATUS_CODE_AB07',
  BANK_STATUS_CODE_AB08 = 'BANK_STATUS_CODE_AB08',
  BANK_STATUS_CODE_AB09 = 'BANK_STATUS_CODE_AB09',
  BANK_STATUS_CODE_AB10 = 'BANK_STATUS_CODE_AB10',
  BANK_STATUS_CODE_AC01 = 'BANK_STATUS_CODE_AC01',
  BANK_STATUS_CODE_AC02 = 'BANK_STATUS_CODE_AC02',
  BANK_STATUS_CODE_AC03 = 'BANK_STATUS_CODE_AC03',
  BANK_STATUS_CODE_AC04 = 'BANK_STATUS_CODE_AC04',
  BANK_STATUS_CODE_AC05 = 'BANK_STATUS_CODE_AC05',
  BANK_STATUS_CODE_AC06 = 'BANK_STATUS_CODE_AC06',
  BANK_STATUS_CODE_AC07 = 'BANK_STATUS_CODE_AC07',
  BANK_STATUS_CODE_AC08 = 'BANK_STATUS_CODE_AC08',
  BANK_STATUS_CODE_AC09 = 'BANK_STATUS_CODE_AC09',
  BANK_STATUS_CODE_AC10 = 'BANK_STATUS_CODE_AC10',
  BANK_STATUS_CODE_AC11 = 'BANK_STATUS_CODE_AC11',
  BANK_STATUS_CODE_AC12 = 'BANK_STATUS_CODE_AC12',
  BANK_STATUS_CODE_AC13 = 'BANK_STATUS_CODE_AC13',
  BANK_STATUS_CODE_AC14 = 'BANK_STATUS_CODE_AC14',
  BANK_STATUS_CODE_AC15 = 'BANK_STATUS_CODE_AC15',
  BANK_STATUS_CODE_AG01 = 'BANK_STATUS_CODE_AG01',
  BANK_STATUS_CODE_AG02 = 'BANK_STATUS_CODE_AG02',
  BANK_STATUS_CODE_AG03 = 'BANK_STATUS_CODE_AG03',
  BANK_STATUS_CODE_AG04 = 'BANK_STATUS_CODE_AG04',
  BANK_STATUS_CODE_AG05 = 'BANK_STATUS_CODE_AG05',
  BANK_STATUS_CODE_AG06 = 'BANK_STATUS_CODE_AG06',
  BANK_STATUS_CODE_AG07 = 'BANK_STATUS_CODE_AG07',
  BANK_STATUS_CODE_AG08 = 'BANK_STATUS_CODE_AG08',
  BANK_STATUS_CODE_AG09 = 'BANK_STATUS_CODE_AG09',
  BANK_STATUS_CODE_AG10 = 'BANK_STATUS_CODE_AG10',
  BANK_STATUS_CODE_AG11 = 'BANK_STATUS_CODE_AG11',
  BANK_STATUS_CODE_AGNT = 'BANK_STATUS_CODE_AGNT',
  BANK_STATUS_CODE_AM01 = 'BANK_STATUS_CODE_AM01',
  BANK_STATUS_CODE_AM02 = 'BANK_STATUS_CODE_AM02',
  BANK_STATUS_CODE_AM03 = 'BANK_STATUS_CODE_AM03',
  BANK_STATUS_CODE_AM04 = 'BANK_STATUS_CODE_AM04',
  BANK_STATUS_CODE_AM05 = 'BANK_STATUS_CODE_AM05',
  BANK_STATUS_CODE_AM06 = 'BANK_STATUS_CODE_AM06',
  BANK_STATUS_CODE_AM07 = 'BANK_STATUS_CODE_AM07',
  BANK_STATUS_CODE_AM09 = 'BANK_STATUS_CODE_AM09',
  BANK_STATUS_CODE_AM10 = 'BANK_STATUS_CODE_AM10',
  BANK_STATUS_CODE_AM11 = 'BANK_STATUS_CODE_AM11',
  BANK_STATUS_CODE_AM12 = 'BANK_STATUS_CODE_AM12',
  BANK_STATUS_CODE_AM13 = 'BANK_STATUS_CODE_AM13',
  BANK_STATUS_CODE_AM14 = 'BANK_STATUS_CODE_AM14',
  BANK_STATUS_CODE_AM15 = 'BANK_STATUS_CODE_AM15',
  BANK_STATUS_CODE_AM16 = 'BANK_STATUS_CODE_AM16',
  BANK_STATUS_CODE_AM17 = 'BANK_STATUS_CODE_AM17',
  BANK_STATUS_CODE_AM18 = 'BANK_STATUS_CODE_AM18',
  BANK_STATUS_CODE_AM19 = 'BANK_STATUS_CODE_AM19',
  BANK_STATUS_CODE_AM20 = 'BANK_STATUS_CODE_AM20',
  BANK_STATUS_CODE_AM21 = 'BANK_STATUS_CODE_AM21',
  BANK_STATUS_CODE_AM22 = 'BANK_STATUS_CODE_AM22',
  BANK_STATUS_CODE_AM23 = 'BANK_STATUS_CODE_AM23',
  BANK_STATUS_CODE_BE01 = 'BANK_STATUS_CODE_BE01',
  BANK_STATUS_CODE_BE04 = 'BANK_STATUS_CODE_BE04',
  BANK_STATUS_CODE_BE05 = 'BANK_STATUS_CODE_BE05',
  BANK_STATUS_CODE_BE06 = 'BANK_STATUS_CODE_BE06',
  BANK_STATUS_CODE_BE07 = 'BANK_STATUS_CODE_BE07',
  BANK_STATUS_CODE_BE08 = 'BANK_STATUS_CODE_BE08',
  BANK_STATUS_CODE_BE09 = 'BANK_STATUS_CODE_BE09',
  BANK_STATUS_CODE_BE10 = 'BANK_STATUS_CODE_BE10',
  BANK_STATUS_CODE_BE11 = 'BANK_STATUS_CODE_BE11',
  BANK_STATUS_CODE_BE12 = 'BANK_STATUS_CODE_BE12',
  BANK_STATUS_CODE_BE13 = 'BANK_STATUS_CODE_BE13',
  BANK_STATUS_CODE_BE14 = 'BANK_STATUS_CODE_BE14',
  BANK_STATUS_CODE_BE15 = 'BANK_STATUS_CODE_BE15',
  BANK_STATUS_CODE_BE16 = 'BANK_STATUS_CODE_BE16',
  BANK_STATUS_CODE_BE17 = 'BANK_STATUS_CODE_BE17',
  BANK_STATUS_CODE_BE18 = 'BANK_STATUS_CODE_BE18',
  BANK_STATUS_CODE_BE19 = 'BANK_STATUS_CODE_BE19',
  BANK_STATUS_CODE_BE20 = 'BANK_STATUS_CODE_BE20',
  BANK_STATUS_CODE_BE21 = 'BANK_STATUS_CODE_BE21',
  BANK_STATUS_CODE_BE22 = 'BANK_STATUS_CODE_BE22',
  BANK_STATUS_CODE_CERI = 'BANK_STATUS_CODE_CERI',
  BANK_STATUS_CODE_CH03 = 'BANK_STATUS_CODE_CH03',
  BANK_STATUS_CODE_CH04 = 'BANK_STATUS_CODE_CH04',
  BANK_STATUS_CODE_CH07 = 'BANK_STATUS_CODE_CH07',
  BANK_STATUS_CODE_CH09 = 'BANK_STATUS_CODE_CH09',
  BANK_STATUS_CODE_CH10 = 'BANK_STATUS_CODE_CH10',
  BANK_STATUS_CODE_CH11 = 'BANK_STATUS_CODE_CH11',
  BANK_STATUS_CODE_CH12 = 'BANK_STATUS_CODE_CH12',
  BANK_STATUS_CODE_CH13 = 'BANK_STATUS_CODE_CH13',
  BANK_STATUS_CODE_CH14 = 'BANK_STATUS_CODE_CH14',
  BANK_STATUS_CODE_CH15 = 'BANK_STATUS_CODE_CH15',
  BANK_STATUS_CODE_CH16 = 'BANK_STATUS_CODE_CH16',
  BANK_STATUS_CODE_CH17 = 'BANK_STATUS_CODE_CH17',
  BANK_STATUS_CODE_CH19 = 'BANK_STATUS_CODE_CH19',
  BANK_STATUS_CODE_CH20 = 'BANK_STATUS_CODE_CH20',
  BANK_STATUS_CODE_CH21 = 'BANK_STATUS_CODE_CH21',
  BANK_STATUS_CODE_CH22 = 'BANK_STATUS_CODE_CH22',
  BANK_STATUS_CODE_CNOR = 'BANK_STATUS_CODE_CNOR',
  BANK_STATUS_CODE_CURR = 'BANK_STATUS_CODE_CURR',
  BANK_STATUS_CODE_CUST = 'BANK_STATUS_CODE_CUST',
  BANK_STATUS_CODE_DNOR = 'BANK_STATUS_CODE_DNOR',
  BANK_STATUS_CODE_DS01 = 'BANK_STATUS_CODE_DS01',
  BANK_STATUS_CODE_DS02 = 'BANK_STATUS_CODE_DS02',
  BANK_STATUS_CODE_DS03 = 'BANK_STATUS_CODE_DS03',
  BANK_STATUS_CODE_DS04 = 'BANK_STATUS_CODE_DS04',
  BANK_STATUS_CODE_DS05 = 'BANK_STATUS_CODE_DS05',
  BANK_STATUS_CODE_DS06 = 'BANK_STATUS_CODE_DS06',
  BANK_STATUS_CODE_DS07 = 'BANK_STATUS_CODE_DS07',
  BANK_STATUS_CODE_DS08 = 'BANK_STATUS_CODE_DS08',
  BANK_STATUS_CODE_DS09 = 'BANK_STATUS_CODE_DS09',
  BANK_STATUS_CODE_DS0A = 'BANK_STATUS_CODE_DS0A',
  BANK_STATUS_CODE_DS0B = 'BANK_STATUS_CODE_DS0B',
  BANK_STATUS_CODE_DS0C = 'BANK_STATUS_CODE_DS0C',
  BANK_STATUS_CODE_DS0D = 'BANK_STATUS_CODE_DS0D',
  BANK_STATUS_CODE_DS0E = 'BANK_STATUS_CODE_DS0E',
  BANK_STATUS_CODE_DS0F = 'BANK_STATUS_CODE_DS0F',
  BANK_STATUS_CODE_DS0G = 'BANK_STATUS_CODE_DS0G',
  BANK_STATUS_CODE_DS0H = 'BANK_STATUS_CODE_DS0H',
  BANK_STATUS_CODE_DS0K = 'BANK_STATUS_CODE_DS0K',
  BANK_STATUS_CODE_DS10 = 'BANK_STATUS_CODE_DS10',
  BANK_STATUS_CODE_DS11 = 'BANK_STATUS_CODE_DS11',
  BANK_STATUS_CODE_DS12 = 'BANK_STATUS_CODE_DS12',
  BANK_STATUS_CODE_DS13 = 'BANK_STATUS_CODE_DS13',
  BANK_STATUS_CODE_DS14 = 'BANK_STATUS_CODE_DS14',
  BANK_STATUS_CODE_DS15 = 'BANK_STATUS_CODE_DS15',
  BANK_STATUS_CODE_DS16 = 'BANK_STATUS_CODE_DS16',
  BANK_STATUS_CODE_DS17 = 'BANK_STATUS_CODE_DS17',
  BANK_STATUS_CODE_DS18 = 'BANK_STATUS_CODE_DS18',
  BANK_STATUS_CODE_DS19 = 'BANK_STATUS_CODE_DS19',
  BANK_STATUS_CODE_DS20 = 'BANK_STATUS_CODE_DS20',
  BANK_STATUS_CODE_DS21 = 'BANK_STATUS_CODE_DS21',
  BANK_STATUS_CODE_DS22 = 'BANK_STATUS_CODE_DS22',
  BANK_STATUS_CODE_DS23 = 'BANK_STATUS_CODE_DS23',
  BANK_STATUS_CODE_DS24 = 'BANK_STATUS_CODE_DS24',
  BANK_STATUS_CODE_DS25 = 'BANK_STATUS_CODE_DS25',
  BANK_STATUS_CODE_DS26 = 'BANK_STATUS_CODE_DS26',
  BANK_STATUS_CODE_DS27 = 'BANK_STATUS_CODE_DS27',
  BANK_STATUS_CODE_DT01 = 'BANK_STATUS_CODE_DT01',
  BANK_STATUS_CODE_DT02 = 'BANK_STATUS_CODE_DT02',
  BANK_STATUS_CODE_DT03 = 'BANK_STATUS_CODE_DT03',
  BANK_STATUS_CODE_DT04 = 'BANK_STATUS_CODE_DT04',
  BANK_STATUS_CODE_DT05 = 'BANK_STATUS_CODE_DT05',
  BANK_STATUS_CODE_DT06 = 'BANK_STATUS_CODE_DT06',
  BANK_STATUS_CODE_DU01 = 'BANK_STATUS_CODE_DU01',
  BANK_STATUS_CODE_DU02 = 'BANK_STATUS_CODE_DU02',
  BANK_STATUS_CODE_DU03 = 'BANK_STATUS_CODE_DU03',
  BANK_STATUS_CODE_DU04 = 'BANK_STATUS_CODE_DU04',
  BANK_STATUS_CODE_DU05 = 'BANK_STATUS_CODE_DU05',
  BANK_STATUS_CODE_DUPL = 'BANK_STATUS_CODE_DUPL',
  BANK_STATUS_CODE_ED01 = 'BANK_STATUS_CODE_ED01',
  BANK_STATUS_CODE_ED03 = 'BANK_STATUS_CODE_ED03',
  BANK_STATUS_CODE_ED05 = 'BANK_STATUS_CODE_ED05',
  BANK_STATUS_CODE_ED06 = 'BANK_STATUS_CODE_ED06',
  BANK_STATUS_CODE_ERIN = 'BANK_STATUS_CODE_ERIN',
  BANK_STATUS_CODE_FF01 = 'BANK_STATUS_CODE_FF01',
  BANK_STATUS_CODE_FF02 = 'BANK_STATUS_CODE_FF02',
  BANK_STATUS_CODE_FF03 = 'BANK_STATUS_CODE_FF03',
  BANK_STATUS_CODE_FF04 = 'BANK_STATUS_CODE_FF04',
  BANK_STATUS_CODE_FF05 = 'BANK_STATUS_CODE_FF05',
  BANK_STATUS_CODE_FF06 = 'BANK_STATUS_CODE_FF06',
  BANK_STATUS_CODE_FF07 = 'BANK_STATUS_CODE_FF07',
  BANK_STATUS_CODE_FF08 = 'BANK_STATUS_CODE_FF08',
  BANK_STATUS_CODE_FF09 = 'BANK_STATUS_CODE_FF09',
  BANK_STATUS_CODE_FF10 = 'BANK_STATUS_CODE_FF10',
  BANK_STATUS_CODE_FF11 = 'BANK_STATUS_CODE_FF11',
  BANK_STATUS_CODE_G000 = 'BANK_STATUS_CODE_G000',
  BANK_STATUS_CODE_G001 = 'BANK_STATUS_CODE_G001',
  BANK_STATUS_CODE_G002 = 'BANK_STATUS_CODE_G002',
  BANK_STATUS_CODE_G003 = 'BANK_STATUS_CODE_G003',
  BANK_STATUS_CODE_G004 = 'BANK_STATUS_CODE_G004',
  BANK_STATUS_CODE_G005 = 'BANK_STATUS_CODE_G005',
  BANK_STATUS_CODE_G006 = 'BANK_STATUS_CODE_G006',
  BANK_STATUS_CODE_ID01 = 'BANK_STATUS_CODE_ID01',
  BANK_STATUS_CODE_MD01 = 'BANK_STATUS_CODE_MD01',
  BANK_STATUS_CODE_MD02 = 'BANK_STATUS_CODE_MD02',
  BANK_STATUS_CODE_MD05 = 'BANK_STATUS_CODE_MD05',
  BANK_STATUS_CODE_MD06 = 'BANK_STATUS_CODE_MD06',
  BANK_STATUS_CODE_MD07 = 'BANK_STATUS_CODE_MD07',
  BANK_STATUS_CODE_MS02 = 'BANK_STATUS_CODE_MS02',
  BANK_STATUS_CODE_MS03 = 'BANK_STATUS_CODE_MS03',
  BANK_STATUS_CODE_NARR = 'BANK_STATUS_CODE_NARR',
  BANK_STATUS_CODE_NERI = 'BANK_STATUS_CODE_NERI',
  BANK_STATUS_CODE_RC01 = 'BANK_STATUS_CODE_RC01',
  BANK_STATUS_CODE_RC02 = 'BANK_STATUS_CODE_RC02',
  BANK_STATUS_CODE_RC03 = 'BANK_STATUS_CODE_RC03',
  BANK_STATUS_CODE_RC04 = 'BANK_STATUS_CODE_RC04',
  BANK_STATUS_CODE_RC05 = 'BANK_STATUS_CODE_RC05',
  BANK_STATUS_CODE_RC06 = 'BANK_STATUS_CODE_RC06',
  BANK_STATUS_CODE_RC07 = 'BANK_STATUS_CODE_RC07',
  BANK_STATUS_CODE_RC08 = 'BANK_STATUS_CODE_RC08',
  BANK_STATUS_CODE_RC09 = 'BANK_STATUS_CODE_RC09',
  BANK_STATUS_CODE_RC10 = 'BANK_STATUS_CODE_RC10',
  BANK_STATUS_CODE_RC11 = 'BANK_STATUS_CODE_RC11',
  BANK_STATUS_CODE_RC12 = 'BANK_STATUS_CODE_RC12',
  BANK_STATUS_CODE_RCON = 'BANK_STATUS_CODE_RCON',
  BANK_STATUS_CODE_RF01 = 'BANK_STATUS_CODE_RF01',
  BANK_STATUS_CODE_RR01 = 'BANK_STATUS_CODE_RR01',
  BANK_STATUS_CODE_RR02 = 'BANK_STATUS_CODE_RR02',
  BANK_STATUS_CODE_RR03 = 'BANK_STATUS_CODE_RR03',
  BANK_STATUS_CODE_RR04 = 'BANK_STATUS_CODE_RR04',
  BANK_STATUS_CODE_RR05 = 'BANK_STATUS_CODE_RR05',
  BANK_STATUS_CODE_RR06 = 'BANK_STATUS_CODE_RR06',
  BANK_STATUS_CODE_RR07 = 'BANK_STATUS_CODE_RR07',
  BANK_STATUS_CODE_RR08 = 'BANK_STATUS_CODE_RR08',
  BANK_STATUS_CODE_RR09 = 'BANK_STATUS_CODE_RR09',
  BANK_STATUS_CODE_RR10 = 'BANK_STATUS_CODE_RR10',
  BANK_STATUS_CODE_RR11 = 'BANK_STATUS_CODE_RR11',
  BANK_STATUS_CODE_RR12 = 'BANK_STATUS_CODE_RR12',
  BANK_STATUS_CODE_S000 = 'BANK_STATUS_CODE_S000',
  BANK_STATUS_CODE_S001 = 'BANK_STATUS_CODE_S001',
  BANK_STATUS_CODE_S002 = 'BANK_STATUS_CODE_S002',
  BANK_STATUS_CODE_S003 = 'BANK_STATUS_CODE_S003',
  BANK_STATUS_CODE_S004 = 'BANK_STATUS_CODE_S004',
  BANK_STATUS_CODE_SL01 = 'BANK_STATUS_CODE_SL01',
  BANK_STATUS_CODE_SL02 = 'BANK_STATUS_CODE_SL02',
  BANK_STATUS_CODE_SL11 = 'BANK_STATUS_CODE_SL11',
  BANK_STATUS_CODE_SL12 = 'BANK_STATUS_CODE_SL12',
  BANK_STATUS_CODE_SL13 = 'BANK_STATUS_CODE_SL13',
  BANK_STATUS_CODE_SL14 = 'BANK_STATUS_CODE_SL14',
  BANK_STATUS_CODE_TA01 = 'BANK_STATUS_CODE_TA01',
  BANK_STATUS_CODE_TD01 = 'BANK_STATUS_CODE_TD01',
  BANK_STATUS_CODE_TD02 = 'BANK_STATUS_CODE_TD02',
  BANK_STATUS_CODE_TD03 = 'BANK_STATUS_CODE_TD03',
  BANK_STATUS_CODE_TM01 = 'BANK_STATUS_CODE_TM01',
  BANK_STATUS_CODE_TS01 = 'BANK_STATUS_CODE_TS01',
  BANK_STATUS_CODE_TS04 = 'BANK_STATUS_CODE_TS04',
}
